const EventEmitter = require('eventemitter3');

const BattleCalc = require('../../BattleCalc');
const DefensiveStanceCondition = require('../../conditions/DefensiveStanceCondition');
const OffensiveStanceCondition = require('../../conditions/OffensiveStanceCondition');
const { logError } = require('../../logger');

const StanceDancing = function (battleState) {
  this.handle = 'stance_dancing';
  this.physical = true;
  this.help = true;

  this.eventEmitter = new EventEmitter();

  this.isLegal = () => true;

  this.execute = function (actor, victim) {
    if (!actor || !actor.inPlay) {
      return;
    }

    try {
      const ability = BattleCalc.getEquippedAbility(actor, 'stance_dancing');

      var result = {};
      result.abilityHandle = this.handle;
      result.actorId = actor.uid;
      result.victimId = victim ? victim.uid : null;

      if (this.stance === 'normal_stance') {
        var stance = BattleCalc.getCondition(actor, 'defensive_stance');
        if (stance) {
          battleState.expireCondition(stance.uid);
        } else {
          stance = BattleCalc.getCondition(actor, 'offensive_stance');
          if (stance) {
            battleState.expireCondition(stance.uid);
          }
        }

        result.success = true;
      } else if (this.stance === 'defensive_stance') {
        const defensiveStance = new DefensiveStanceCondition(
          actor,
          victim,
          battleState,
          ability.potency
        );
        defensiveStance.actorId = actor.uid;
        defensiveStance.victimId = victim.uid;

        battleState.onUnitCondition(defensiveStance);

        result.success = true;
        result.newStance = defensiveStance;
      } else if (this.stance === 'offensive_stance') {
        const offensiveStance = new OffensiveStanceCondition(
          actor,
          victim,
          battleState,
          ability.potency
        );
        offensiveStance.actorId = actor.uid;
        offensiveStance.victimId = victim.uid;

        battleState.onUnitCondition(offensiveStance);

        result.success = true;
        result.newStance = offensiveStance;
      }
      result.allPieces = battleState.allPieces;
      this.eventEmitter.emit('result', result);
    } catch (err) {
      logError(err, {
        module: 'StanceDancing',
        func: 'execute',
        actor,
        victim,
      });

      return { success: false };
    }
  };
};
module.exports = StanceDancing;
